<div class="desktop-view">
  <table>
    <thead>
      <tr>
        <td>Номер</td>
        <td>Номер заказа</td>
        <td>Дата</td>
        <td>Сумма</td>
        <td></td>
      </tr>
    </thead>

    <tbody>
      <ng-container *ngIf="loading; else loadedDesktop">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonColumns"><div class="skeleton"></div></td>
        </tr>
      </ng-container>

      <ng-template #loadedDesktop>
        <tr *ngFor="let item of items">
          <td>
            <span [title]="item.number">{{ item.number }}</span>
          </td>
          <td>
            <span [title]="item.orderCode">{{ item.orderCode }}</span>
          </td>
          <td>
            <span [title]="item.date | date: 'dd.MM.YYYY'">{{ item.date | date: 'dd.MM.YYYY' }}</span>
          </td>
          <td>
            <span [title]="item.formattedTotalPayment">{{ item.formattedTotalPayment }}</span>
          </td>
          <td>
            <sd-document-download-button [id]="item.uid"></sd-document-download-button>
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>

<div class="mobile-view">
  <ng-container *ngIf="loading; else loadedMobile">
    <div *ngFor="let row of skeletonRows" class="skeleton"></div>
  </ng-container>

  <ng-template #loadedMobile>
    <div class="document-item" *ngFor="let item of items">
      <div class="document-item-title">
        <h4>Счет фактура № {{ item.number }}</h4>
      </div>
      <div class="document-item-text">Заказ № {{ item.orderCode }} от {{ item.date | date: 'dd.MM.YYYY' }}</div>
      <div class="document-item-text">Сумма {{ item.formattedTotalPayment }}</div>
      <div>
        <sd-document-download-button [id]="item.uid"></sd-document-download-button>
      </div>
    </div>
  </ng-template>
</div>
